import { render, staticRenderFns } from "./AddUploadsDialog.vue?vue&type=template&id=33a454de&"
import script from "./AddUploadsDialog.vue?vue&type=script&lang=ts&"
export * from "./AddUploadsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports